import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { Table } from "react-bootstrap";
import Scrollbar from "react-scrollbars-custom";
import "./pcr.css";
import "./PcrUploadXMLAlert.css";

export default function PcrUploadXMLAlert(props) {
  const { displayData, allGPCOkay, toggleModal } = props;
  const positive = displayData.positive.length > 0;
  const retest = displayData.retest.length > 0;
  const error = displayData.error.length > 0;
  const noResutls = displayData.positive.length === 0
    && displayData.retest.length === 0
    && displayData.error.length === 0;
  return (
    <div>
      <SweetAlert
        confirmBtnBsStyle="btn-hide"
        onConfirm={() => {}}
        customClass="PcrUploadXMLAlert__SweetAlert"
        title=""
        onCancel={toggleModal}
        closeOnClickOutside={false}
        allowEscape={false}
      >
        <div className="pcrXMLModalHeaderContainer">
          <div>
            <div>
              Plate Name:
              {" "}
              {displayData.plate_name}
            </div>
            <div>
              Instrument:
              {" "}
              {displayData.instrument}
            </div>
          </div>
          <div>
            <div className="pcrXMLModalHeaderClose">
              <div>
                Created On:
                {" "}
                {displayData.created_on}
              </div>
              <p className="pcrXMLCloseButton" onClick={toggleModal}>
                ✖
              </p>
            </div>
          </div>
        </div>

        {allGPCOkay ? (
          <div className="pcrXMLAllGpc">
            <p>{allGPCOkay}</p>
          </div>
        ) : (
          <Scrollbar
            disableTrackYWidthCompensation
            disableTracksWidthCompensation
            id="pcrUploadXMLScrollbar"

          >
            {noResutls ? (
              <div className="pcrXMLAllGpc">
                <p>All Negative</p>
              </div>
            ) : (
              <Table className="pcrXMLAlertTable">
                <thead className="pcrXMLAlertTableHeading">
                  <tr>
                    {positive && <td>Positive</td>}
                    {retest && <td>Retest</td>}
                    {error && <td>Errors</td>}
                  </tr>
                </thead>
                <tbody className="pcrXMLAlertTableBody">
                  <tr>
                    {positive && (
                      <td>
                        <div className="pcrXMLAlertTableTd">
                          {displayData.positive.map((item, index) => (
                            <div
                              key={index + item.genista_id}
                              className="PcrUploadXMLAlert__Cell"
                            >
                              <div>
                                {" "}
                                <span className="pcrXMLAlertTitle">
                                  Genista ID:
                                  {" "}
                                </span>
                                {item.genista_id}
                              </div>
                              <div>
                                {" "}
                                <span className="pcrXMLAlertTitle">Test: </span>
                                {item.test}
                                {" "}
                              </div>
                            </div>
                          ))}
                        </div>
                      </td>
                    )}
                    {retest && (
                      <td>
                        <div className="pcrXMLAlertTableTd">
                          {displayData.retest.map((item, index) => (
                            <div
                              key={index + item.genista_id}
                              className="PcrUploadXMLAlert__Cell"
                            >
                              <div>
                                {" "}
                                <span className="pcrXMLAlertTitle">
                                  Genista ID:
                                  {" "}
                                </span>
                                {item.genista_id}
                              </div>
                              <div>
                                {" "}
                                <span className="pcrXMLAlertTitle">Test: </span>
                                {item.test}
                                {" "}
                              </div>
                            </div>
                          ))}
                        </div>
                      </td>
                    )}
                    {error && (
                      <td>
                        <div className="pcrXMLAlertTableTd">
                          {displayData.error.map((item, index) => (
                            <div key={index + item.genista_id}>
                              <div>
                                {" "}
                                <span className="pcrXMLAlertTitle">
                                  Result:
                                  {" "}
                                </span>
                                {item.result}
                              </div>
                              <div>
                                {" "}
                                <span className="pcrXMLAlertTitle">Test: </span>
                                {item.test}
                              </div>
                            </div>
                          ))}
                        </div>
                      </td>
                    )}
                  </tr>
                </tbody>
              </Table>
            )}
          </Scrollbar>
        )}
        {/* {props.allGPCOkay ? (
          <div className="pcrXMLAllGpc">
            <div className="pcrXMLModalHeaderContainer">
              <p className="pcrXMLCloseButton" onClick={props.toggleModal}>
                ✖
              </p>
            </div>

            <p>{props.allGPCOkay}</p>
          </div>
        ) : (
          <table style={{width: "50vw", height: "40vh"}}>
            <thead className="pcrXMLAllGpcTableHeader">
              <tr>
                {positive && <td>Positive</td>}
                {retest && <td>Retest</td>}
                {error && <td>Errors</td>}
              </tr>
            </thead>
            <tbody className="pcrXMLAllGpcTableBody">
              <tr>
                {positive && (
                  <td>
                    <div style={{display:"flex", flexDirection: "column"}}>
                      {displayData.positive.map((item, index) => <div key={index + item.genista_id}>
                      <div>{item.genista_id}</div>
                        <div>{item.test} </div>
                      </div>)}
                    </div>
                  </td>
                )}
                {retest && (
                  <td>
                    <div style={{display:"flex", flexDirection: "column"}}>
                      {displayData.retest.map((item, index) => <div key={index + item.genista_id}>
                        <div>{item.genista_id}</div>
                        <div>{item.test} </div>
                      </div>)}
                    </div>
                  </td>
                )}
                {error && (
                  <td>
                    <div style={{display:"flex", flexDirection: "column"}}>
                      {displayData.error.map((item, index) => <div key={index + item.genista_id}>
                        <div>{item.genista_id}</div>
                        <div>{item.result}</div>
                        <div>{item.test} </div>
                      </div>)}
                    </div>
                  </td>
                )}
              </tr>
            </tbody>
          </table>
        )} */}
      </SweetAlert>
    </div>
  );
}
